import React from "react";
import "./App.css";

interface State {
  readonly isProcessing: boolean;
}

export class App extends React.Component<{}, State> {
  /**
   * React uses `isMounted` under the hood, so redeclaring a property with the same name would lead to an error.
   * Hence, we use the `openslf_` prefix to avoid conflicts.
   */
  private openslf_isMounted: boolean;

  constructor(props: {}) {
    super(props);

    this.state = { isProcessing: true };
    this.openslf_isMounted = false;
  }

  componentDidMount(): void {
    this.openslf_isMounted = true;
    setTimeout(() => {
      if (!this.openslf_isMounted) {
        return;
      }

      this.setState({ isProcessing: false });
    }, 3000 + 3000 * Math.random());
  }

  componentWillUnmount(): void {
    this.openslf_isMounted = false;
  }

  render(): React.ReactElement {
    if (!window.location.href.includes("transaction_id=")) {
      return (
        <div className="App">
          <section className="ProcessingBox">
            <p>Loading application...</p>

            <p className="PoweredBy">
              Powered by <a href="https://github.com/openslf">Open SLF</a>.
            </p>

            <span className="LoadingSpinner" />
          </section>
        </div>
      );
    }

    if (this.state.isProcessing) {
      return (
        <div className="App">
          <section className="ProcessingBox">
            <p>Processing your donation...</p>

            <p className="PoweredBy">
              Powered by <a href="https://github.com/openslf">Open SLF</a>.
            </p>

            <span className="LoadingSpinner" />
          </section>
        </div>
      );
    }

    return (
      <div className="App">
        <section className="ProcessingBox">
          <p>Sorry, we could not process your credit card.</p>

          <p>We sincerely apologize for the inconvenience.</p>

          <p className="PoweredBy">
            Powered by <a href="https://github.com/openslf">Open SLF</a>.
          </p>
        </section>
      </div>
    );
  }
}
